export const trimString = (string, maxLength) => {
  if (!string) return "";
  return string && string.length > maxLength
    ? string.substring(0, maxLength - 3) + "..."
    : string;
};
